import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { CTAButton } from './CTAButton';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative pt-20 pb-16 px-6 md:px-8 max-w-2xl mx-auto text-center" data-id="element-86">
      <AnimatedSection data-id="element-87">
        <span className="inline-block text-gold uppercase tracking-widest text-sm font-semibold mb-6" data-id="element-88">
          Un método de 21 días
        </span>

        <h1 className="text-5xl md:text-6xl font-serif text-bark mb-4 leading-tight" data-id="element-89">
          Devoción sin Culpa
        </h1>

        <p className="text-xl md:text-2xl text-bark/80 font-serif italic mb-10" data-id="element-90">
          21 días para volver a rezar (aunque estés agotada)
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="my-12 flex justify-center" data-id="element-91">
          <img src="https://cdn.magicpatterns.com/uploads/qBUYsrjBDTf7ZorQC4156f/heylloyd-image-1771129581573.png" alt="Devoción sin Culpa — ebook mostrado en una tablet sobre una mesa de noche" className="w-full max-w-md rounded-sm shadow-2xl shadow-bark/15" data-id="element-92" />
        </motion.div>

        <div className="space-y-6 text-lg md:text-xl text-bark/90 leading-relaxed text-left md:text-center max-w-xl mx-auto" data-id="element-93">
          <p data-id="element-94">No te falta fe. Te falta aire.</p>
          <p data-id="element-95">
            Y cuando una mujer no tiene aire, lo primero que se cae no es el
            trabajo… es lo invisible: la oración.
          </p>
          <p data-id="element-96">Porque nadie te felicita por rezar.</p>
          <p data-id="element-97">Pero vos sí te castigás cuando no lo hacés.</p>
          <p data-id="element-98">
            Si estás leyendo esto con esa mezcla rara de amor por Dios y culpa
            encima, quiero decirte algo incómodo y liberador a la vez:
          </p>

          <div className="py-4" data-id="element-99">
            <p className="font-bold text-xl md:text-2xl text-wine" data-id="element-100">
              No abandonaste a Dios. Intentaste sostener una vida espiritual con
              un formato que no entra en tu vida real.
            </p>
          </div>
        </div>

        <div className="mt-12" data-id="element-101">
          <CTAButton data-id="element-102">Quiero el plan</CTAButton>
        </div>
      </AnimatedSection>
    </section>;
}